module.exports = __webpack_public_path__ + "static/media/gb.c4cd6642.svg";